import { Component } from '@angular/core';

@Component({
  selector: 'app-no-autorizado',
  templateUrl: './no-autorizado.component.html',
  styleUrls: ['./no-autorizado.component.css'],
  standalone: true,
  imports: [
    
  ]
})
export class NoAutorizadoComponent  {

}
